import * as ReactAccordion from "@radix-ui/react-accordion";
import styled from "styled-components";

export const AccordionItem = styled(ReactAccordion.Item)`
  box-shadow: 2px 4px 4px rgba(208, 210, 218, 0.25),
    0px 18px 32px rgba(208, 210, 218, 0.15);
  background-color: #fff;
  border-radius: 16px;
  margin-bottom: 28px;
  overflow: hidden;
`;

export const AccordionTrigger = styled(ReactAccordion.Trigger)`
  padding: 16px 20px;
  width: 100%;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  line-height: 1.2;
  color: #1f4ca0;

  svg {
    height: 12px;
    fill: #1f4ca0;
    transition: transform 0.3s;
  }

  &[data-state="closed"] {
    svg {
      transform: rotate(-90deg);
    }
  }
`;

export const AccordionContent = styled(ReactAccordion.Content)`
  padding: 0 20px 12px;

  h1 {
    font-size: 1.2em;
    line-height: 1.2;
    font-weight: inherit;
  }

  .attachment--preview {
    width: 100%;
    text-align: center;
  }

  .attachment__caption {
    color: #666;
    font-size: 0.9em;
  }

  &[data-state="open"] {
    animation: slideDown 0.3s;
  }

  &[data-state="closed"] {
    animation: slideUp 0.3s;
  }

  @keyframes slideDown {
    from {
      height: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
    }
  }

  @keyframes slideUp {
    from {
      height: var(--radix-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
`;
